export interface IModel {
  id: number | null
  createdAt: Date | null
}

export class Model implements IModel {
  public id: number | null = null
  public createdAt: Date | null = null
}
